<template>
  <div class="integrations">
    <h1 class="page-title">Integrations</h1>

    <div class="page-content -column -column-one -form">
      <ul class="section-nav">
        <li :class="{ '-active': creatingNew }">
          <a href="#" @click.prevent="creatingNew = true">Add new Integration</a>
        </li>

        <li
          v-for="integration in integrations"
          :key="integration.label"
          :class="{ '-active': !creatingNew && currentIntegration === integration }"
        >
          <a href="#" @click.prevent="viewIntegration(integration)">{{ integration.label }}</a>
        </li>
      </ul>
    </div>

    <div v-if="creatingNew" class="page-content -column -column-two basic-list -mt">
      <h3 class="section-title -mb">Add new Integration</h3>
      <integration-form :integration="newIntegration" @saved="viewIntegration"></integration-form>
    </div>

    <div v-if="!creatingNew && currentIntegration" class="page-content -column -column-two basic-list -mt">
      <h3 class="section-title -mb">{{ currentIntegration.label }}</h3>

      <ul>
        <li><strong>Platform:</strong> {{ currentIntegration.platform }}</li>
        <li v-if="currentIntegration.platform === 'fb_messenger'">
          <strong>FB Page ID:</strong> {{ currentIntegration.metadata.fb_page_id }}
        </li>
        <li v-if="currentIntegration.platform === 'fb_messenger'">
          <strong>FB Access Token:</strong> {{ currentIntegration.metadata.fb_access_token }}
        </li>
        <li v-if="currentIntegration.platform === 'fb_messenger'">
          <strong>FB Verify Code:</strong> {{ currentIntegration.metadata.fb_verify_code }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import integrationForm from "@/components/integrationForm";
import auth from "@/helpers/auth";

export default {
  components: { integrationForm },
  beforeRouteEnter(to, from, next) {
    if (!auth.signedIn()) return next("/sign-in");
    next();
  },

  data() {
    return {
      creatingNew: false,
      newIntegration: {
        platform: "",
        label: "",
        metadata: {
          fb_page_id: "",
          fb_access_token: ""
        }
      }
    };
  },

  computed: {
    ...mapState({
      integrations: (state) => state.integrations.all,
      currentIntegration: (state) => state.integrations.current
    })
  },

  methods: {
    viewIntegration(integration) {
      this.creatingNew = false;
      this.$store.dispatch("changeCurrentIntegration", integration.id);
    }
  }
};
</script>
